// extracted by mini-css-extract-plugin
module.exports = {"survey":"SurveyList_survey__0NlZD","finishItemContainer":"SurveyList_finishItemContainer__Q9xs3"};